import type { IconType } from '@graftcode/design-system'
import { Icon } from '@graftcode/design-system'

/** Academy side nav: regular glyph when idle, filled when row is active (Figma Academy side panel). */
const REGULAR_TO_FILLED: Partial<Record<IconType, IconType>> = {
  [Icon.HomeRegular]: Icon.HomeFilled,
  [Icon.FastForwardRegular]: Icon.FastForwardFilled,
  [Icon.DocumentRegular]: Icon.DocumentFilled,
  [Icon.BookRegular]: Icon.BookFilled,
  [Icon.VideoRegular]: Icon.VideoFilled,
}

export function getAcademyNavIcon(icon: IconType, isActive: boolean): IconType {
  if (!isActive) {
    return icon
  }
  return REGULAR_TO_FILLED[icon] ?? icon
}
